<template>
  <div class="card custom-shadow rounded-3 bg-white border mb-4 pb-4">
    <div
      class="d-flex justify-content-between align-items-center gap-2 position-relative custom-padding-30"
      style="top: -5px"
    >
      <h3 class="mb-0 fs-18 fw-semibold">Upcoming Episodes</h3>
      <div class="dropdown action-opt right-for-rtl" style="right: -8px">
        <button
          class="btn bg-transparent p-0 text-end"
          type="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <i data-feather="more-vertical" style="stroke: #64748b"></i>
        </button>
        <ul class="dropdown-menu dropdown-menu-end bg-white border box-shadow">
          <li>
            <a class="dropdown-item" href="javascript:;">
              <i data-feather="clock"></i>
              Today
            </a>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:;">
              <i data-feather="pie-chart"></i>
              Last 7 Days
            </a>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:;">
              <i data-feather="rotate-cw"></i>
              Last Month
            </a>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:;">
              <i data-feather="calendar"></i>
              Last 1 Year
            </a>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:;">
              <i data-feather="bar-chart"></i>
              All Time
            </a>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:;">
              <i data-feather="eye"></i>
              View
            </a>
          </li>
          <li>
            <a class="dropdown-item" href="javascript:;">
              <i data-feather="trash"></i>
              Delete
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="last-child-none">
      <div
        v-for="episode in episodes"
        :key="episode.id"
        class="d-flex gap-2 justify-content-between align-items-center border-bottom border-body-bg custom-padding-30 pt-0 child"
        style="margin-bottom: 13.5px; padding-bottom: 13.5px"
      >
        <div class="d-flex">
          <div class="flex-shrink-0">
            <div
              class="text-center rounded-circle"
              :class="episode.iconBgClass"
              style="width: 40px; height: 40px; line-height: 40px"
            >
              <img :src="episode.icon" alt="notice-board-icon" />
            </div>
          </div>
          <div class="flex-grow-1 ms-10">
            <h4 class="fs-14 fw-medium mb-0">{{ episode.title }}</h4>
            <p class="fs-12 mb-0">{{ episode.author }}</p>
            <div class="d-flex align-items-center">
              <i class="ri-calendar-line text-primary"></i>
              <span class="fw-medium fs-12 text-primary ms-1">{{
                episode.date
              }}</span>
            </div>
          </div>
        </div>
        <button
          class="rounded-circle d-inline-block text-center hover-bg for-dark-read text-decoration-none border bg-transparent"
          style="width: 43px; height: 43px; line-height: 42px; color: #b1bbc8"
        >
          <i class="ri-arrow-right-up-line fs-24"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "UpcomingEpisodes",
  data() {
    return {
      episodes: [
        {
          id: 1,
          title: "AI for Content Strategy",
          author: "Amanda Garcia",
          date: "October 20, 2024",
          icon: require("@/assets/images/notice-board-icon-1.svg"),
          iconBgClass: "bg-primary-div",
        },
        {
          id: 2,
          title: "Secrets to Viral Marketing",
          author: "Sarah Johnson",
          date: "October 25, 2024",
          icon: require("@/assets/images/notice-board-icon-2.svg"),
          iconBgClass: "bg-primary",
        },
        {
          id: 3,
          title: "Social Media Strategy",
          author: "David Chen",
          date: "October 28, 2024",
          icon: require("@/assets/images/notice-board-icon-3.svg"),
          iconBgClass: "bg-danger",
        },
        {
          id: 4,
          title: "Content Trends for 2025",
          author: "Tom Richards",
          date: "November 3, 2024",
          icon: require("@/assets/images/notice-board-icon-4.svg"),
          iconBgClass: "bg-card-bg-c",
        },
      ],
    };
  },
});
</script>
